import type { SVGProps } from 'react';
import { cn } from '@/components/ui';

export type IllustrationSvgProps = SVGProps<SVGSVGElement> & {
  /** Unique prefix for gradient ids when multiple illustrations mount on one page. */
  idPrefix: string;
};

export function IllustrationSvg({
  idPrefix,
  className,
  children,
  ...rest
}: IllustrationSvgProps) {
  const grad = `${idPrefix}-grad`;
  const soft = `${idPrefix}-soft`;

  return (
    <svg
      viewBox="0 0 400 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={cn('marketing-hero-illustration__svg', className)}
      {...rest}
    >
      <defs>
        <linearGradient id={grad} x1="48" y1="40" x2="352" y2="260" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--color-primary)" />
          <stop offset="1" stopColor="var(--color-secondary)" />
        </linearGradient>
        <linearGradient id={soft} x1="0" y1="300" x2="400" y2="0" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--color-primary)" stopOpacity="0.14" />
          <stop offset="1" stopColor="var(--color-secondary)" stopOpacity="0.1" />
        </linearGradient>
      </defs>
      <rect width="400" height="300" rx="28" fill={`url(#${soft})`} />
      {children}
    </svg>
  );
}
